import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType'
import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloDiscountRatio extends AloBase {    
    flxId:number    
    itfTypObj:ItemfluxObjectType
    discountFid:number
    mrqId:number|null
    discountRatio :number
}

export const getDefaultAloDiscountRatio = ():AloDiscountRatio => {
    return {
        ...getDefaultAloBase(),
        flxId:0,        
        itfTypObj:ItemfluxObjectType.Univers,
        discountFid:0,
        mrqId:null,
        discountRatio :0
    }
}

export const cleanAloDiscountRatio = (discountRatioItem:AloDiscountRatio) => {
    if(!discountRatioItem) return
    if(!discountRatioItem.id) delete discountRatioItem.id
    if(!discountRatioItem.mrqId) delete discountRatioItem.mrqId
}